import React, { FC } from "react";

const MenuIcon: FC<any> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 377.003 355.122">
    <path d="M361.775 156.879H15.23c-8.41 0-15.23 9.259-15.23 20.682 0 11.423 6.82 20.682 15.23 20.682h346.545c8.41 0 15.228-9.259 15.228-20.682 0-11.422-6.817-20.682-15.228-20.682zm0-156.879H15.23C6.82 0 0 9.26 0 20.682c0 11.422 6.82 20.682 15.23 20.682h346.545c8.41 0 15.228-9.26 15.228-20.682C377.003 9.26 370.186 0 361.775 0zm-122.56 313.758H15.23C6.82 313.758 0 323.017 0 334.44c0 11.423 6.82 20.682 15.23 20.682h223.985c8.411 0 15.229-9.259 15.229-20.682 0-11.423-6.818-20.682-15.229-20.682z" />
  </svg>
);

export default MenuIcon;
